/* eslint-disable */
import React, { useEffect } from "react";
import { useDrag, useDrop } from "react-dnd";


// Example image data



const Card = ({ src, title, id, index, caption, moveImage, deleteImage, updateCaption }) => {
    const ref = React.useRef(null);
    const [isHovered, setIsHovered] = React.useState(false);

    const [, drop] = useDrop({
        accept: "image",
        hover: (item, monitor) => {
            if (!ref.current) return;
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) return;

            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if ((dragIndex > hoverIndex && hoverClientY > hoverMiddleY)) return;

            moveImage(dragIndex, hoverIndex);
            item.index = hoverIndex;
        }
    });

    const [{ isDragging }, drag] = useDrag({
        type: "image",
        item: { id, index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    });

    const opacity = isDragging ? 0 : 1;
    drag(drop(ref));

    return (
        <div
            ref={ref}
            style={{
                opacity,
                cursor: "move",
                height: "100%",
                width: "100%",
                aspectRatio: "16/9",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: "#f9f9f9",
                marginBottom: "10px",
                position: "relative",
                transition: "all 0.2s ease-in-out",
                transform: isDragging ? "scale(1.05)" : "scale(1)",
                boxShadow: isHovered
                    ? "0 0 10px 2px rgba(0, 123, 255, 0.7)"
                    : "0 2px 4px rgba(0, 0, 0, 0.1)",
                border: isHovered ? "2px solid #007bff" : "2px solid transparent"
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <img
                src={src}
                alt={title}
                style={{
                    height: "80%",
                    width: "100%",
                    objectFit: "cover"
                }}
            />
            {/* Caption Input */}
            <input
                type="text"
                placeholder="Enter caption..."
                value={caption || ""}
                onChange={(e) => updateCaption(e.target.value)}
                style={{
                    width: "90%",
                    margin: "5px 0",
                    padding: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    fontSize: "14px"
                }}
            />

            {/* Delete Button */}
            <button
                onClick={() => deleteImage(id)}
                style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    backgroundColor: "rgba(255, 0, 0, 0.7)",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: "28px",
                    height: "28px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    zIndex: 10
                }}
            >
                ×
            </button>
        </div>
    );
};

const ImageDragList = ({ data, setValue, captionsData, setCaptionsData }) => {
    const [images, setImages] = React.useState(data);
    const [captions, setCaptions] = React.useState(captionsData);

    React.useEffect(() => {
        if (data) {
            setImages(data);
        }
    }, [data]);

    React.useEffect(() => {
        if (captionsData) {
            setCaptions(captionsData);
        }
    }, [captionsData]);

    const moveImage = React.useCallback((dragIndex, hoverIndex) => {

        setImages(prev => {
            const cloned = [...prev];
            const [removed] = cloned.splice(dragIndex, 1);

            cloned.splice(hoverIndex, 0, removed);
            return cloned;
        });

        setValue(prev => {
            const cloned = [...prev];
            const [removed] = cloned.splice(dragIndex, 1);

            cloned.splice(hoverIndex, 0, removed);
            return cloned;
        });
    }, []);

    const deleteImage = React.useCallback((name) => {
        setImages((prevCards) => prevCards.filter((img) => img.name !== name));
        setValue((prevCards) => prevCards.filter((img) => img.name !== name));
    }, []);

    // Calculate total size in MB
    const totalSizeMB = images.reduce((acc, img) => acc + (img.size || 0), 0) / (1024 * 1024);

    return (
        <div
            style={{
                backgroundColor: "white",
                borderRadius: "4px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                width: "100%",
                display: "grid",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
                gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
                padding: "20px"
            }}
        >
            {totalSizeMB < 60 && <div style={{ gridColumn: "1 / -1", marginBottom: "10px", fontWeight: "bold" }}>
                Size Limit: {totalSizeMB.toFixed(2)} MB / 60MB
            </div>}

            {totalSizeMB >= 60 && <div style={{ gridColumn: "1 / -1", marginBottom: "10px", fontWeight: "bold", color: "red" }}>
                Size Limit Exceeded: {totalSizeMB.toFixed(2)} MB / 60MB
            </div>}

            {images.map((image, index) => {
                let caption = captions[image.name] || "";
                console.log(`url: ${URL.createObjectURL(image)}`)
                console.log(`caption: ${caption}`)

                return <Card
                    caption={caption}
                    key={image.name}
                    src={URL.createObjectURL(image)}
                    title={image.name}
                    id={image.name}
                    index={index}
                    moveImage={moveImage}
                    deleteImage={deleteImage}
                    updateCaption={(captionData) => {
                        setCaptions({ ...captions, [image.name]: captionData });
                        setCaptionsData({ ...captions, [image.name]: captionData })
                    }}
                />;
            })}
        </div>
    );
};

export default ImageDragList;
